var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{class:['c-main', { 'c-main--disabled': _setup.props.disabled }]},[(_vm.$slots['tela-titulo'])?_c('h2',[_vm._t("tela-titulo")],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }